<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on }">
      <v-btn
        class="select-documents"
        :class="[setClass]"
        v-on="on"
        depressed
        outlined
        height="32px"
      >
        {{ $t('common.common_document') }}
      </v-btn>
    </template>
    <v-list>
      <v-list-item
        v-for="(item, i) in itemLists"
        :key="i"
        @click="submit(item)"
      >
        <v-list-item-content>
          <v-list-item-title>
            {{ $t(item.title) }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    isRowInfo: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({}),
  computed: {
    ...mapGetters('User', ['authority']),
    itemLists() {
      // 見積書
      const quotation = {
        title: 'sale.sale_quotation',
        type: 'quotation'
      }
      // 請求書
      const bill = {
        title: 'sale.sale_invoice',
        type: 'bill'
      }
      // 請求書 (振り込み口座指定)
      const account = {
        title: 'sale.sale_transfer-account-designation-invoice',
        type: 'account'
      }
      // 請求書 (返金履歴指定)
      const refund = {
        title: 'sale.sale_refund-history-designation-invoice',
        type: 'refund'
      }
      // 出庫先一覧 (CSV)
      const csv = {
        title: 'sale.sale_csv-ship-list',
        type: 'csv'
      }
      // 販売履歴一覧（CSV）
      const saleHistoryCsv = {
        title: 'sale.sale_sale-history-list-csv',
        type: 'saleHistoryCsv'
      }
      // 一括請求書
      const combinedBill = {
        title: 'sale.sale_combined-bill',
        type: 'combinedBill'
      }
      if (this.isRowInfo) {
        return [quotation, bill, account, refund]
      }

      if (this.authority.isOutsideStaff) {
        return [csv, saleHistoryCsv]
      }

      if (!this.authority.isFunction1) {
        return [quotation, bill, account, refund, csv, saleHistoryCsv]
      }

      return [
        quotation,
        bill,
        account,
        refund,
        csv,
        saleHistoryCsv,
        combinedBill
      ]
    },
    setClass() {
      const color = this.color == 'white' ? '' : this.color
      return 'font-weight-bold ' + 'white' + ' ' + 'thinText--text'
    }
  },
  methods: {
    submit(item) {
      this.$emit('submit', item.type)
    }
  }
}
</script>

<style lang="scss" scoped>
.select-documents {
  width: 60px;
  height: 32px !important;
  font-size: 12px;
  border: thin solid #c8cfd7 !important;
}
</style>
